import { render, staticRenderFns } from "./PrintableBehaviourQuestion.vue?vue&type=template&id=15ca430c&scoped=true&"
import script from "./PrintableBehaviourQuestion.vue?vue&type=script&lang=js&"
export * from "./PrintableBehaviourQuestion.vue?vue&type=script&lang=js&"
import style0 from "./PrintableBehaviourQuestion.vue?vue&type=style&index=0&id=15ca430c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ca430c",
  null
  
)

export default component.exports